<section>
  <div class="container">
    <div class="reviews">
      <div class="review">
        <div class="review__Title">App Store</div>
        <app-star-rating />
        <span class="review__Main">4.8 {{ 'txt-stars' | translate }}</span>
        <span>&nbsp; </span>
        <span class="review__Text">57,7K+ {{ 'txt-reviews' | translate }}</span>
      </div>

      <div class="review">
        <div class="review__Title">Google Play</div>
        <app-star-rating />
        <span class="review__Main">4.7 {{ 'txt-stars' | translate }}</span>
        <span>&nbsp; </span>
        <span class="review__Text">18K+ {{ 'txt-reviews' | translate }}</span>
      </div>

      <div class="review">
        <div class="review__Title">{{ 'txt-supporting' | translate }}</div>
        <div class="review__Main">3 {{ 'txt-millions' | translate }}</div>
        <span class="review__spacer">&nbsp; </span>
        <div class="review__Text">{{ 'txt-cyclers-over-10-years' | translate }}</div>
      </div>
    </div>
  </div>
</section>
